import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import ChatList from "../../components/ChatList/ChatList";
import PrivateChat from "../../components/ChatList/PrivateChat";
import userimg from "../../assets/img/user.png";
import "./PrivateMessage.css";
import NullPageComponent from "../../components/Tile/NullPageComponent";
import {
  MessageMarkAsRead,
  PrivateMessageList,
} from "../../services/privateMessages.service";
import useAuthService from "../../auth/AuthService";
import { IPrivateMessageList } from "../../types/types";
import { handleDateWithTime } from "../../utils/formatdate";

interface State {
  isLoading: boolean;
  isChatLoading: boolean;
  isList: boolean;
  FanPrivateMessageList: IPrivateMessageList[];
  PrivateMessageList: IPrivateMessageList[];
  MessageHistoryList: IPrivateMessageList[];
  selectedChat: IPrivateMessageList;
  message: string;

  socket: WebSocket | null;
  chatHistory: any[];
}

const MessagePage: React.FC = () => {
  const { getToken } = useAuthService();
  const navigate = useNavigate();

  // State to manage current view and selected chat
  const [state, setState] = useState<State>({
    isLoading: false,
    isChatLoading: false,
    isList: true,
    FanPrivateMessageList: [] as IPrivateMessageList[],
    PrivateMessageList: [] as IPrivateMessageList[],
    MessageHistoryList: [] as IPrivateMessageList[],
    selectedChat: {} as IPrivateMessageList,
    message: "",

    socket: null as WebSocket | null,
    chatHistory: [] as any[],
  });

  // useEffect(() => {
  //   const FatchData = async () => {
  //     try {
  //       setState((pre) => ({ ...pre, isLoading: true }));
  //       var response: any = null;
  //       response = await PrivateMessageList(getToken);
  //       if (response.error) {
  //         setState((pre) => ({ ...pre, PrivateMessageList: [] }));
  //         return;
  //       }
  //       setState((pre) => ({
  //         ...pre,
  //         FanPrivateMessageList:
  //           response.data.fan_private_message_list !== null
  //             ? response.data.fan_private_message_list
  //             : [],
  //         PrivateMessageList:
  //           response.data.private_message_list !== null
  //             ? response.data.private_message_list
  //             : [],
  //         MessageHistoryList:
  //           response.data.message_history_list !== null
  //             ? response.data.message_history_list
  //             : [],
  //         loggedInId: response.data.loggedInID,
  //       }));
  //     } catch (error) {
  //       console.error("An error occurred while fetching data", error);
  //     } finally {
  //       setState((pre) => ({ ...pre, isLoading: false }));
  //     }
  //   };
  //   FatchData();
  //   //eslint-disable-next-line
  // }, []);

  useEffect(() => {
    const FatchData = async () => {
      try {
        setState((pre) => ({ ...pre, isLoading: true }));
        var response: any = null;
        response = await PrivateMessageList(getToken);
        if (response.error) {
          setState((pre) => ({ ...pre, PrivateMessageList: [] }));
          return;
        }

        const fanMessages = response.data.fan_private_message_list ?? [];
        const privateMessages = response.data.private_message_list ?? [];
        const historyMessages = response.data.message_history_list ?? [];

        const topMessage =
          fanMessages[0] || privateMessages[0] || historyMessages[0] || null;

        setState((pre) => ({
          ...pre,
          FanPrivateMessageList: fanMessages,
          PrivateMessageList: privateMessages,
          MessageHistoryList: historyMessages,
          loggedInId: response.data.loggedInID,
        }));

        const isDesktop = window.innerWidth >= 768;
        // Automatically open the top message if no chat is selected
        if (
          isDesktop &&
          Object.keys(topMessage).length !== 0 &&
          Object.keys(state.selectedChat).length === 0
        ) {
          if (topMessage) {
            handleOpenSelect(topMessage);
            setState((pre) => ({ ...pre, isList: true }));
          }
        }
      } catch (error) {
        console.error("An error occurred while fetching data", error);
      } finally {
        setState((pre) => ({ ...pre, isLoading: false }));
      }
    };

    FatchData();
    //eslint-disable-next-line
  }, []);

  const FetchMessageList = async () => {
    try {
      const response = await PrivateMessageList(getToken);
      if (response.error) {
        setState((pre) => ({ ...pre, PrivateMessageList: [] }));
        return;
      }
      setState((pre) => ({
        ...pre,
        FanPrivateMessageList:
          response.data.fan_private_message_list !== null
            ? response.data.fan_private_message_list
            : [],
        PrivateMessageList:
          response.data.private_message_list !== null
            ? response.data.private_message_list
            : [],
        MessageHistoryList:
          response.data.message_history_list !== null
            ? response.data.message_history_list
            : [],
        loggedInId: response.data.loggedInID,
      }));
    } catch (error) {
      console.error("An error occurred while fetching data", error);
    }
  };

  const MarkAsRead = async (sender_id: string, receiver_id: string) => {
    try {
      const response = await MessageMarkAsRead(getToken, {
        sender_id: sender_id,
        receiver_id: receiver_id,
      });
      if (response.error) {
        console.error("An error occurred while Mark as Read", response.error);
        return;
      } else {
        await FetchMessageList();
      }
    } catch (error) {
      console.error("An error occurred while Mark as Read", error);
    }
  };

  const handleOpenSelect = async (entity: IPrivateMessageList) => {
    // Switch to chat view
    setState((prev) => ({
      ...prev,
      message: "",
      isList: false,
      isChatLoading: prev.selectedChat.id !== entity.id ? true : false,
      selectedChat:
        prev.selectedChat.id !== entity.id
          ? entity
          : ({} as IPrivateMessageList),
      chatHistory: [],
    }));
    entity.is_read && MarkAsRead(entity.id, entity.sender_id);
    setTimeout(() => {
      setState((prev) => ({ ...prev, isChatLoading: false }));
    }, 1000);
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setState((pre) => ({ ...pre, message: e.target.value }));
  };

  useEffect(() => {
    if (Object.keys(state.selectedChat).length > 0) {
      if (state.socket) {
        state.socket.close();
      }
      const ws = new WebSocket(
        `${process.env.REACT_APP_FAN1_WEBSOCKET_URL}/private/ws?sender_id=${state.selectedChat.sender_id}&receiver_id=${state.selectedChat.id}`
      );

      ws.onopen = () => {
        console.log("WebSocket connected");
      };

      ws.onmessage = (event) => {
        let parsedMessage: any = {};
        let messageContent: any = event.data;

        try {
          parsedMessage = JSON.parse(event.data);
          messageContent = parsedMessage.content;
        } catch (error) {
          console.error("WebSocket message parse error:", error);
        }

        const isRelated =
          parsedMessage.sender_id === state.selectedChat.id ||
          parsedMessage.receiver_id === state.selectedChat.id;

        if (!isRelated) return;

        const isSender =
          (state.selectedChat.is_entity &&
            parsedMessage.sender_id === state.selectedChat.id) ||
          (!state.selectedChat.is_entity &&
            parsedMessage.sender_id === state.selectedChat.sender_id);

        const newMessage = {
          id: state.chatHistory.length + 1,
          type: isSender ? "sender" : "receiving",
          message: messageContent,
          timestamp: handleDateWithTime(parsedMessage.timestamp),
          sender_image_url: parsedMessage.sender_image_url,
          sender_name: parsedMessage.sender_name,
        };

        setState((prev) => ({
          ...prev,
          chatHistory: [...prev.chatHistory, newMessage],
        }));
      };

      setState((prev) => ({ ...prev, socket: ws }));

      return () => {
        ws.close();
      };
    }
    // eslint-disable-next-line
  }, [state.selectedChat]);

  const sendMessageToSocket = () => {
    if (state.socket && state.message) {
      const messageData = {
        sender_id: state.selectedChat.sender_id,
        receiver_id: state.selectedChat.id,
        content: state.message,
      };
      MarkAsRead(state.selectedChat.id, state.selectedChat.sender_id);
      state.socket.send(JSON.stringify(messageData));
      setState((pre) => ({
        ...pre,
        message: "",
      }));
    }
  };

  return (
    <div className="container message-main sliding-content px-2">
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      {/* Messages/Alerts Buttons */}
      <div
        className={`font-500-44 my-3 title d-lg-block ${
          state.isList ? "d-block" : "d-none"
        }`}
      >
        Messages
      </div>
      <div
        className={`d-flex d-lg-flex my-3  justify-content-between ${
          state.isList ? "d-flex" : "d-none"
        }`}
      >
        <div className="d-flex">
          <Button
            variant="none"
            className="active-pill-buttons font-500-18"
            onClick={() => navigate("/message")}
            label={<>Messages</>}
          />
          <Button
            variant="none"
            className="btn pill-buttons ms-3 font-500-18"
            onClick={() => navigate("/alerts")}
            label={<>Alerts</>}
          />
        </div>
      </div>

      {/* Back Button and Selected Chat Name */}
      <div
        className={`d-flex align-items-end d-lg-none ${
          state.isList ? "d-none" : "d-block"
        }`}
        style={{ width: "100%" }}
      >
        <div
          className="icon-circle"
          onClick={() =>
            setState((prev) => ({
              ...prev,
              isList: true,
              selectedChat: {} as IPrivateMessageList,
            }))
          }
        >
          <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div
          className="mx-auto text-center"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={state.selectedChat?.image_url || userimg}
            className="img-fluid"
            style={{ height: "40px", width: "40px", borderRadius: "10px" }}
            alt="User"
          />
          <h3 className="m-0">{state.selectedChat?.name || "Select a Chat"}</h3>
        </div>
      </div>

      {/* If no unread messages*/}
      {Object.keys(state.PrivateMessageList).length <= 0 &&
      Object.keys(state.FanPrivateMessageList).length <= 0 &&
      Object.keys(state.MessageHistoryList).length <= 0 ? (
        <NullPageComponent
          heading1={"You don't have any messages yet."}
          heading2={
            "Purchase a membership for one-to-one conversation with who you admire most!"
          }
          button1={
            <>
              <Button
                label="Go to Rankings"
                className="btn"
                onClick={() => navigate("/rankings")}
                variant="dark"
              />
              <Button
                label="Go to Available now!"
                className="btn"
                onClick={() => navigate("/available")}
                variant="dark"
              />
            </>
          }
        />
      ) : (
        <>
          {/* Chat List and Private Chat */}
          <div className="sliding-row row mt-4">
            {/* Left Panel: Chat List */}
            <div
              className={`col-lg-4 col-12 left-panel left-slide-panel m-0 ${
                state.isList ? "active" : ""
              }`}
            >
              <ChatList
                selected={state.selectedChat.id}
                FanChats={state.FanPrivateMessageList}
                Chats={state.PrivateMessageList}
                HistoryChats={state.MessageHistoryList}
                onSelect={handleOpenSelect}
              />
            </div>

            {/* Right Panel: Private Chat */}
            <div
              className={`col-lg-8 col-12 right-slide-panel container ${
                state.isList ? "" : "active"
              }`}
            >
              <div className="private-chat">
                {state.isChatLoading ? (
                  <div className="inside-loader h-100">
                    <div className="spinner"></div>
                  </div>
                ) : (
                  <>
                    {Object.keys(state.selectedChat).length > 0 ? (
                      <PrivateChat
                        isEntityChat={state.selectedChat.is_entity}
                        figName={state.selectedChat.name}
                        chatHistory={state.chatHistory}
                        newMessage={state.message}
                        onSendMessage={sendMessageToSocket}
                        onChange={handleChange}
                        msgEnable={state.selectedChat.is_active}
                      />
                    ) : (
                      <div className="text-center my-5">
                        Select a chat to start messaging
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MessagePage;
